export default {
  legal: {
    identity: {
      title: '请选择事业类型',
      legal: '法人',
      personal: '个体户',
    },
    basic: {
      title: '法人基本情报（＊必填项）',
      title_p:'个体户基本情报（＊必填项）',
      number: '法人编号',
      numberTip: '半角数字13位',
      checkTag: '適格請求書発行事業者',
      reminderText: '如果您是合格发票开具经营者，请勾选此项',

      label1: '法人名称',
      tip1: '例：株式会社〇〇',
      label2: '全角片假名',
      tip2: '例：カブシキガイシャ○○',
      label3: '英语表记',
      tip3: '例：○〇 Co., Ltd.',
      label4: '法人设立年月日',
      tip4: '2010/1/1',
      label5: '法人类别',
      tip5: '',
      label6: '商号或法人简称',
      label6tip: '在结算页面显示',
      label6_p: '个体户简称（商号）',
      tip6: '例：环球支付',
      label7: '全角片假名',
      tip7: '例：カンキュウシフ',
      label8: '英文名称',
      tip8: '例：GLOBEPAY',
      label9: '公司网址',
      tip9: '例：https://www.globepay.co.jp',
      label10: '注册资本金（单位：万日元）',
      tip10: '请输入前期整个公司的年销售额。如果成立未满1年，请输入预计年销售额。',
      label11: '资本金（单位：万日元）',
      tip11: '',
      label12: '员工人数（单位：人）',
      tip12: '',
       label13: '法人格位置',
      tip13: ''
    },
    industry: {
      title: '行业信息（＊必填项）',
      label1: '行业（类别）',
      tip1: '选择',
      label2: '行业（详细）',
      tip2: '选择',
      label3: '主营业务及具体商品',
      tip3: '例：经营餐厅',
      label4: '销售商品最低单价/日元',
      tip4: '',
      label5: '销售商品最高单价/日元',
      tip5: '',
    },
    address:{
      title:'公司地址（＊必填项）',
      label1:'邮政编码',
      tip1:'例：1030026',
      stateLabel:'都道府号',
      cityLabel:'市区町村',
      streetLabel:'町名',
      extendedLabel:'番地',
      extended:'番地',
      state:'例：東京都',
      city:'例：中央区',
      street:'例：日本橋兜町',
      label2:'全角片假名',
      tip2_1:'例：トウキョウト',
      tip2_2:'例：チュウオウク',
      tip2_3:'例：ニホンバシカブトチョウ',
      label3:'建筑物名称及房间编号',
      tip3:'例：1-1008',
      label4:'全角片假名',
      tip4:'例：ニホンバシカブトチョウ',
      label5:'电话号码',
      tip5:'例：03-6284-2302',
       label6:'传真',
      tip6:'例：090-1234-5678',
       label7:'紧急联系方式',
      tip7:'紧急联系方式',
      mobile:'移动手机号码',
      mobiletip:'移动手机号码',


    },
    representative:{
      title:'法人代表信息',
      firstName:'姓',
      lastName:'名',
      fullWidth:'全角片假名',
      enName:'英语表记',
      tip1:'例：高桥',
      tip2:'例：タカハシ',
      tip3:'例：TAKAHASHI',
      tip4:'例：一郎',
      tip5:'例：イチロウ',
      tip6:'例：ICHIRO',
      birthday: '生年月日',
      tip7:'例：2010-01-01',
      sex:'性别'
    },
    home:'法人代表住址',
    head:{
      title:'负责人信息【环球支付可能会联系贵司负责人】',
      email:'电子邮件',
      emaildetail: 'メールアドレスの形式が不正です',
      jobtitle:'职位',
      tip:'例：xxx@gmail.com',
      help:'※ 邮箱地址非常重要。我们将通过此邮箱联系您关于申请内容，并发送支付系统的ID/密码。',

    }
  }
}
